import { useState, useEffect, useRef } from 'react';
import { Menu } from '../menu/menu';
import logo from '../../../../assets/images/logo.png';
import './mobile-menu.css';

export const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleButtonRef = useRef(null);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
        toggleButtonRef.current?.focus();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  return (
    <div className="mobile-wrapper">
      <img src={logo} style={{ width: '90px' }} alt="Хореографічна студія «Мрія»" />
      <button
        ref={toggleButtonRef}
        type="button"
        className={`hamburger ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-expanded={isOpen}
        aria-controls="mobile-menu-panel"
        aria-label={isOpen ? 'Закрити меню' : 'Відкрити меню'}
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={closeMenu}>
          <div
            id="mobile-menu-panel"
            className="modal-content"
            role="dialog"
            aria-modal="true"
            aria-label="Меню навігації"
            onClick={(e) => e.stopPropagation()}
          >
            <Menu onToggleMenu={toggleMenu} />
          </div>
        </div>
      )}
    </div>
  );
};
